export class PwdRule {
  checkboxClass: string;
  labelClass: string;

  constructor(isCorrect: boolean = false) {
    this.setStyles(isCorrect);
  }

  setStyles(isCorrect: boolean = false): void {
    this.checkboxClass = isCorrect ? pwdRuleStyles.checkbox.correct : pwdRuleStyles.checkbox.incorrect;
    this.labelClass = isCorrect ? pwdRuleStyles.label.correct : pwdRuleStyles.label.incorrect;
  }
}

const pwdRuleStyles = {
  checkbox: {
    correct: 'password-rule-checkbox-checked',
    incorrect: 'password-rule-checkbox',
  },
  label: {
    correct: 'password-rule-label-checked',
    incorrect: 'password-rule-label',
  },
};
